import { InitOverrideFunction, SettingsApi } from "../../../@api";

export class SettingsApiService
  implements Omit<SettingsApi, `${string}Raw` | "withMiddleware" | "withPreMiddleware" | "withPostMiddleware">
{
  constructor(private readonly api: SettingsApi) {}

  public async settingsShouldPersistChatGet(initOverrides?: RequestInit | InitOverrideFunction): Promise<boolean> {
    return this.api.settingsShouldPersistChatGet(initOverrides);
  }
}
